module.exports = __webpack_public_path__ + "static/spinner_blue-8b2d32c31b16b39da4ae8c9add5f5e30.gif";